import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.categoriaFormulario.fields.id'),
  },
  {
    name: 'nombre',
    label: i18n('entities.categoriaFormulario.fields.nombre'),
  },
  {
    name: 'incluirEstadisticas',
    label: i18n('entities.categoriaFormulario.fields.incluirEstadisticas'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.categoriaFormulario.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.categoriaFormulario.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
